import Promise from 'bluebird';
import React from 'react';
import ReactFileReader from 'react-file-reader';
import Modal from 'react-modal';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import {NotificationManager} from "react-notifications";

import * as AdminActions from "../../../../actions/admin"

class ImportFilesDialog extends React.Component {

    static propTypes = {
        onClose: PropTypes.func.isRequired,
        onSuccess: PropTypes.func,
        importType: PropTypes.string,
    };

    static defaultProps = {
        onSuccess: null,
        exportType: null,
    };

    constructor(props) {
        super(props);
        this.state = {
            files: [],
        }
    }

    render() {
        const fileExtentions = [...Array(100).keys()].map(i => '.' + String(i).padStart(2, '0'));
        return <div>
            <Modal
                isOpen={true}
                onRequestClose={() => {this.props.onClose()}}
                style={{
                    overlay: {
                        zIndex: 10,
                    },
                    content : {
                        height: '500px',
                        width: '500px',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }
                }}
            >
                <div className="dialog">
                    <div className="dialog-title">Importer</div>

                    <div className="dialog-body">
                        <div className="dialog-inner-body">
                            <ReactFileReader id="import-files" fileTypes={fileExtentions} base64={false} multipleFiles={true} handleFiles={this.onFilesSelect}>
                                <button onClick={e => e.preventDefault()} className="btn-primary">Vælg filer</button>
                            </ReactFileReader>

                            <div className="scrollable section-files" style={{maxHeight: '310px', overflow: 'auto', marginTop: '25px'}}>
                                <table>
                                    <tbody>
                                    {this.state.files.map((file, ix) => <tr>
                                        <td>{file.name}</td>
                                        {this.props.importType === 'section-stat' ? [
                                            <td key="section">Sektion {file.section}</td>,
                                            <td key="year">20{file.year}</td>
                                        ] : null}
                                        <td>
                                            <i className="fa fa-trash clickable" onClick={() => {
                                                this.state.files.splice(ix, 1);
                                                this.forceUpdate();
                                            }} />
                                        </td>
                                    </tr>)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="actions-row">
                        <button className="btn-primary" disabled={this.state.files.length === 0} onClick={this.onImport}>Importer</button>
                        <button className="btn-secondary float-right" onClick={() => {this.props.onClose()}}>Annuller</button>
                    </div>
                </div>
            </Modal>
        </div>
    }

    onFilesSelect = async (filelist) => {
        const fileIds = [];
        for (const prop in filelist) {
            if (filelist.hasOwnProperty(prop) && /^[0-9]+$/.test(prop)) {
                fileIds.push(prop);
            }
        }
        let isFilesSelected = false;
        let messages = [];
        await Promise.all(fileIds.map(async id => {
            if (this.props.importType === 'section-stat') {
                if (/^SEKSTA[0-9]{2}\.[0-9]{2}$/.test(filelist[id].name.toUpperCase())) {
                    isFilesSelected = true;
                    const file = this.state.files.find(file => file.name === filelist[id].name.toUpperCase());
                    if (file) file.content = await filelist[id].text();
                    else this.state.files.push({
                        name: filelist[id].name.toUpperCase(),
                        content: await filelist[id].text(),
                        year: filelist[id].name.substr(6, 2),
                        section: filelist[id].name.substr(9, 2),
                    });
                } else messages.push({
                    title: "Ugyldigt filnavn " + filelist[id].name,
                    description: "Filer med sektionsstatistik skal være navngivet SEKSTA(ÅÅ).(SS), hvor (ÅÅ) er årstal og (SS) er sektionsnummer.",
                });
            } else {
                isFilesSelected = true;
                const file = this.state.files.find(file => file.name === filelist[id].name.toUpperCase());
                if (file) file.content = await filelist[id].text();
                else this.state.files.push({
                    name: filelist[id].name.toUpperCase(),
                    content: await filelist[id].text(),
                });
            }
        }));
        if (isFilesSelected) this.forceUpdate();
        messages.forEach(msg => {
            NotificationManager.error(msg.description, msg.title, 10000);
        });
    };

    onImport = () => {
        if (this.props.importType === 'section-stat') {
            if (this.state.files.length) this.props.dispatch(AdminActions.importSectionStat(this.state.files.map(file => ({
                section: file.section,
                year: file.year,
                content: file.content,
            })), () => {
                NotificationManager.success("De valgte statistikfiler er uploadet til databasen.", "Import", 4000);
                this.props.onClose();
            }))
        }
    };
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(ImportFilesDialog);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/home/dialogs/ImportFilesDialog.js